const spinnerMessages: string[] = [
    `Solving...`,
    `You wouldn't happen to have a quantum computer would you? `,
    `This might take a while...`,
    `Hold on...`,
]

export default spinnerMessages